import {useAppRoute} from '../useAppRoute';
import ToastContext, {ToastContextType} from '@/context/ToastContext';
import {useContext} from 'react';
import {ToastType} from '@/ui-kits';
import {toastDuration} from '@/constants';

// how that can expose the showToast method for displaying toast messages
export function useToast() {
  const {addToast} = useContext<ToastContextType>(ToastContext);
  const route = useAppRoute();
  // // display only one toast on each screen
  const id = route.name;

  // wrapper for addToast to pass id into add toast while only exposing other attribute
  function showToast(message: string, type: ToastType) {
    addToast(`${id}-${Date.now()}`, '', message, type, toastDuration);
  }

  return {showToast};
}
